import Modal            from '~/js/components/Modal';
import DisplayOptions   from './DisplayOptions';
import Card             from './Card';

const { Component, Fragment } = React;

class RoomsSuitesContainer extends Component {
    state = {
        modalTitle: '',
        modalDetails: '',
    }

    updateModalState = (modalTitle, modalDetails) => {

        return () => {
            this.setState({ modalTitle, modalDetails });
        };
    }

    render() {
        const { rooms, resortCode, uris, roomLevel, hideRefine, toggleGridView, isGrid, countIcons } = this.props;
        const modalId = 'mdl-promotion';

        return (
            <Fragment>
                <DisplayOptions roomsFound={ rooms.length } roomLevel={ roomLevel } hideRefine={hideRefine} toggleGridView={toggleGridView} isGrid={isGrid}/>
                <div className={ `list-grid-viewer-grid js-list-grid-viewer-grid row row-flex ${ !isGrid && 'list-enabled'}`}>
                    {
                        rooms.map( (roomObj = {}) => {

                            const {features = [], rate = {}, promotions = [], ...room} = roomObj;

                            return (
                                <Card
                                    key={ 'card-' + room.roomCategoryCode }
                                    modalId={modalId}
                                    updateModalState={this.updateModalState}
                                    room={room}
                                    rate={rate}
                                    uris={uris}
                                    features={features}
                                    promotions={promotions}
                                    isGrid={isGrid}
                                    countIcons={countIcons}
                                    resortCode={resortCode} />
                            );
                        } )
                    }

                    <Modal id={modalId} title={this.state.modalTitle} content={this.state.modalDetails} />
                </div>
            </Fragment>
        );
    }
}

RoomsSuitesContainer.defaultProps = {
    rooms: [],
    resortCode: '',
    uris: {},
    roomLevel: '',
    hideRefine: false,
    toggleGridView: () => {},
    isGrid: false,
    countIcons: 0,
};

export default RoomsSuitesContainer;
